/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrTextColumn } from './igr-text-column';
import { TextColumn } from './TextColumn';
import { TypeRegistrar } from "igniteui-react-core";
var IgrTextColumnModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrTextColumnModule() {
    }
    IgrTextColumnModule.register = function () {
        TypeRegistrar.registerCons("IgrTextColumn", IgrTextColumn);
        TypeRegistrar.register("TextColumn", TextColumn.$type);
    };
    return IgrTextColumnModule;
}());
export { IgrTextColumnModule };
//# sourceMappingURL=igr-text-column-module.js.map
